import { render } from "./Gender.vue?vue&type=template&id=e35c565c"
import script from "./Gender.vue?vue&type=script&lang=js"
export * from "./Gender.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__